<template>
  <a :href="dateObject.url" target="_blank" class="video-content-item">
    <div class="video-content-img">
      <img :src="dateObject.coverImg" class="module-click" />
      <button v-if="tab.key === 'vipCard'" class="fee-button">领域会员卡</button>
    </div>
    <div class="video-detailed">
      <p class="rowspan module-click video-title">{{ dateObject.courseTitle }}</p>
      <template v-if="tab.key==='studyRecord'">
        <!-- 学习记录展示观看时长 -->
        <span>学习时间 {{ dateObject.studyTime | formateDate }}</span>
      </template>
      <template v-else>
        <span>购买时间 {{ dateObject.orderCreateTime | formateDate }}</span>
      </template>
      <div class="bottomx">
        <el-progress
          v-if="tab.key === 'studyRecord'"
          :class="{'opacity-0': Number(dateObject.learningPercentage)<=0}"
          class="progress"
          :percentage="Number(dateObject.learningPercentage)"
          :format="formatProgress"
          color="#409EFF"
        ></el-progress>
        <div>
          <a :href="dateObject.url" target="_blank">继续学习</a>
          <button v-if="tab.key!=='studyRecord'">课程详情</button>
        </div>
      </div>
    </div>
  </a>
</template>

<script>

export default {
  name: 'GeekTimeCourseItem',
  props: {
    dateObject: {
      type: Object,
    },
    tab: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  filters: {
    formateDate(val) {
      return new Date(val).toLocaleString()
    }
  },
  methods: {
    formatProgress(percentage) {
      if(percentage>100) percentage = 100;
      return percentage.toFixed(1)+'%';
    }
  }
};
</script>

<style lang="less" scoped>
.video-content-item {
  display: flex;
  margin-bottom: 16px;
  cursor: pointer;

  .video-content-img {
    position: relative;
    width: 156px;
    height: 88px;
    background: #f5f6f7;
    border-radius: 2px;
    margin-right: 12px;

    img {
      width: 156px;
      height: 88px;
      background: #f5f6f7;
      border-radius: 2px;
      object-fit: cover;
    }

    button {
      position: absolute;
      top: 6px;
      left: 6px;
      width: 66px;
      height: 24px;
      border-radius: 2px;
    }
    .fee-button {
      background: #222226;
      font-size: 12px;
      font-weight: 400;
      color: #fae8d0;
      line-height: 20px;
    }
    .vip-button {
      background: linear-gradient(270deg, #f8c883 0%, #fae8d0 100%);

      font-size: 14px;
      font-weight: 400;
      color: #69421b;
      line-height: 20px;
    }
  }

  .video-detailed {
    position: relative;

    .video-title {
      font-weight: 500;
    }

    p {
      width: 598px;
      font-size: 14px;
      font-weight: 400;
      color: #555666;
      line-height: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 12px;
    }

    span {
      margin-bottom: 20px;
      display: block;
      font-size: 12px;
      font-weight: 400;
      color: #555666;
      line-height: 16px;
    }

    .bottomx {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .progress {
        width: 150px;
      }

      a {
        padding: 6px;
        font-size: 12px;
        text-decoration: underline;
        color: #222226;
      }

      button {
        width: 64px;
        height: 24px;
        background: #ffffff;
        border: 0;
        font-size: 12px;
        font-weight: 400;
        color: #222226;
        line-height: 16px;
      }
    }
  }
  .opacity-0 {
    opacity: 0;
  }

  @media screen and (max-width: 1440px) {
    .video-detailed {
      width: calc(~"100% - 168px") !important;
    }
  }
}
</style>